export default {
    "ar": "messages_ar.d5bceb3ea9d5471776e373ec794a5094.json",
    "de": "messages_de.c50eb0713f54d4624404643a8bdcd4b7.json",
    "en-GB": "messages_en-GB.90bda41578d07e3a646afbcf4b0efe0c.json",
    "en-US": "messages_en-US.3f2e7a2e02c695cf495abd054de309f0.json",
    "en": "messages_en.c1a83c8ec4c8fb0302096dd9bb9f00ca.json",
    "es": "messages_es.3b92c8eceea39af0eb03e342fdcd14ba.json",
    "et": "messages_et.1a3dc141a11883108f13bfa17dab9b38.json",
    "fr-CA": "messages_fr-CA.f5dddfd3bf19f097786483b9d67f6f33.json",
    "fr": "messages_fr.835aa2d33e91eec9a2681e3ef0b89d96.json",
    "hi": "messages_hi.76b44bb0a46eb0abc8556239d0e0ff6c.json",
    "it": "messages_it.ec393809a7bc79f2b47e47540e9edddc.json",
    "ja": "messages_ja.8454939dfa5b42b3e6227808408358b0.json",
    "nl": "messages_nl.49af4e14aa2dc812bc6d26e8ebec30c5.json",
    "pl": "messages_pl.5a38096c5aec24ced9ce0258c823e0a4.json",
    "pt-BR": "messages_pt-BR.5049cb6daeeb9dccbfab59c713980ca7.json",
    "pt": "messages_pt.be10163f05eb5574e14952f51a051e39.json",
    "ru": "messages_ru.2cbfe6f37c5beecc1470294da3943bf6.json",
    "th": "messages_th.c445f4797ce943041da268e07cae88c2.json",
    "tr": "messages_tr.7c861659571402264fc0acc1d7237aed.json",
    "uk": "messages_uk.70fad6206e393454692b0605e026ddac.json",
    "vi": "messages_vi.04ef85a6cbc20eef74be6933f0fc25d4.json",
    "zh-Hans": "messages_zh-Hans.bc924e99b7f526735077809b56a42769.json",
    "zh-Hant": "messages_zh-Hant.e258b20f3dcc85f7c8fba4d3c4901561.json"
};